import { Injectable, InjectionToken, inject } from '@angular/core';

import { AppSettingsService } from '../../../app-settings.service';
import { buildLoginAppUrl } from './login-app-url';

export interface BrowserLocation {
  href: string;
}

export const BROWSER_LOCATION = new InjectionToken<BrowserLocation>('BROWSER_LOCATION', {
  providedIn: 'root',
  factory: (): BrowserLocation => globalThis.location,
});

/** Tracks an in-flight LoginApp redirect so upload can stay silent during 401 hand-off. */
@Injectable({ providedIn: 'root' })
export class LoginRedirectService {
  private readonly location = inject(BROWSER_LOCATION);
  private readonly appSettings = inject(AppSettingsService);

  private redirectInProgress = false;

  inProgress(): boolean {
    return this.redirectInProgress;
  }

  redirectTo(url: string): void {
    this.redirectInProgress = true;
    this.location.href = url;
  }

  redirectToLoginApp(): void {
    const loginUrl = this.appSettings.appConfig?.LOGIN_APP_FE_URL?.trim();
    if (!loginUrl) {
      return;
    }
    this.redirectTo(buildLoginAppUrl(loginUrl, this.location.href, this.appSettings.appConfig?.MTP_APPLICATION_CODE));
  }
}
